import ApiKeyManagementModal from "v2/api-key-management/components/modals/ApiKeyManagementModal";


export const path = "api-keys";

export const Component = ApiKeyManagementModal;
